import styled from 'styled-components'
import Copy from '../Copy'
import { themeColor, themeFontSize, themeFontWeight } from '../../util/themeLenses'
import { fontSize, fontWeight, lineHeight } from '../../util/styles'

const mediaScreenMobile = props => `@media screen and (min-width: ${props.theme.screens.medium})`

export const STATUS_FINISH = 'finish'
export const STATUS_PROCESS = 'process'
const getColor = ({status, theme}) => {
    if (status == STATUS_FINISH || status == STATUS_PROCESS){
        return themeColor(theme.components.stepper.main)
    } else {
        return  themeColor('gray90')
    }
}

export const StepsTitle = styled.span`
    color: ${({theme}) => themeColor(theme.components.stepper.main)};
    white-space: inherit;
    overflow: auto;
    text-overflow: initial;
    display: none;
    ${fontSize}
    ${fontWeight}
    ${lineHeight}

    ${mediaScreenMobile} {
        overflow: visible;
        width: fit-content;
        font-size: ${themeFontSize('small')};
        display: inline-block;
        padding-top: 0px;
    }
`

StepsTitle.defaultProps = {
    fontSize: 'xxSmall',
    fontWeight: 'medium',
    lineHeight: 'xSmall',
}

export const StepsTitleMobile = styled(StepsTitle)`
    display: flex;
    font-weight: ${themeFontWeight('medium')};
    font-size: ${themeFontSize('xxSmall')};
    align-items: flex-start;
    ${mediaScreenMobile} {
        display: none;
        font-size: ${themeFontSize('small')};
    }
`
const unfinishedStyles = props => `
    color: ${getColor(props)};
    display: none;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: ${themeFontWeight('medium')(props)};
    ${mediaScreenMobile(props)} {
        font-size: ${themeFontSize('small')(props)};
        line-height: calc(${themeFontSize('small')(props)} * 1.2);
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
`

export const StepsUnfinishedCurrentTitle = styled.h1`
    ${props => unfinishedStyles(props)}
`

export const StepsUnfinishedTitle = styled.span`
    ${props => unfinishedStyles(props)}
`

export const StepsUnfinishedMobileTitle = styled(StepsUnfinishedTitle)`
    display: block;
    font-size: ${themeFontSize('xxSmall')};
    font-weight: ${themeFontWeight('medium')};
    line-height: calc(${themeFontSize('small')} * 1.2);
    text-align: center;
    align-items: center;
    ${mediaScreenMobile} {
        font-size: ${themeFontSize('small')};
        display: none;
        padding-left: 12px;
    }
`
export const StepsUserName = styled(Copy)`
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 24em;
    white-space: nowrap;
`
export const StepsUserEmail = styled(StepsUserName)`
    max-width: 30em;
`

export const StepDatesBlock = styled.div`
    &:first-child {
        border-right: 2px solid ${themeColor('main60')};
        padding-right: 16px;
        margin-right: 12px;
    }
`
export const StepsContentText = styled.div`
    color: ${themeColor('black')};
    font-size: ${themeFontSize('xxSmall')};
    font-weight: ${themeFontWeight('book')};
    ${mediaScreenMobile} {
        font-size: ${themeFontSize('small')};
    }
`

export const StepsContentTextEllipsis = styled(StepsContentText)`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`

export const StepsLabelText = styled(StepsContentText)`
    color: ${themeColor('gray80')};
    font-weight: ${themeFontWeight('regular')};
    text-transform: uppercase;
    margin-bottom: 2px;
    margin-right: 8px;
`
